<template>
  <a-drawer
      title="广告播放详情"
      placement="right"
      :width="'80%'"
      :visible="visible"
      @close="$emit('update:visible', false)"
  >
    <a-alert
        type="info"
        show-icon
        class="mb-3"
        :message="`时间范围：${dateRangeText}`"
    />

    <a-table
        :columns="columns"
        :data-source="list"
        :pagination="pagination"
        :loading="loading"
        rowKey="id"
        @change="onPageChange"
    />
  </a-drawer>
</template>

<script>
import { privilegeActiviteDetail } from '@/api/statistics/privilege-activate'

export default {
  name: 'ActivateDetailDrawer',
  props: {
    visible: Boolean,
    dateRange: Array
  },
  data() {
    return {
      loading: false,
      list: [],
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0
      },
      columns: [
        { title: '用户 ID', dataIndex: 'userId', key: 'userId' },
        { title: '用户名称', dataIndex: 'userName', key: 'userName' },
        { title: '激活时间', dataIndex: 'activationTime', key: 'activationTime' }
      ]
    }
  },
  computed: {
    dateRangeText() {
      if (!this.dateRange || this.dateRange.length !== 2) return ''
      return `${this.dateRange[0].format('YYYY-MM-DD')} 至 ${this.dateRange[1].format('YYYY-MM-DD')}`
    }
  },
  watch: {
    visible(val) {
      if (val) this.loadData()
    }
  },
  methods: {
    onPageChange(pagination) {
      this.pagination.current = pagination.current
      this.loadData()
    },
    loadData() {
      if (!this.dateRange || this.dateRange.length !== 2) return

      this.loading = true
      privilegeActiviteDetail({
        startDate: this.dateRange[0].format('YYYY-MM-DD'),
        endDate: this.dateRange[1].format('YYYY-MM-DD'),
        pageNum: this.pagination.current,
        pageSize: this.pagination.pageSize
      }).then(res => {
        this.list = res.data.records || []
        this.pagination.total = res.data.total || 0
      }).finally(() => {
        this.loading = false
      })
    }
  }
}
</script>

<style scoped>
.mb-3 {
  margin-bottom: 16px;
}
</style>
